import { addDays, addWeeks, format, isSameWeek, startOfWeek } from "date-fns";
import { ptBR } from "date-fns/locale";
import { currentWorkDay, dateToDateOnly } from "@/lib/format";
import type { WeekRange } from "../types";

const WEEK_OPTIONS = { weekStartsOn: 1 } as const;

export function weekStart(reference: Date): Date {
	return startOfWeek(reference, WEEK_OPTIONS);
}

export function weekRange(reference: Date): WeekRange {
	const start = weekStart(reference);
	return {
		from: dateToDateOnly(start),
		to: dateToDateOnly(addDays(start, 6)),
	};
}

export function weekDates(reference: Date): Date[] {
	const start = weekStart(reference);
	return Array.from({ length: 7 }, (_, index) => addDays(start, index));
}

export function shiftWeeks(reference: Date, amount: number): Date {
	return addWeeks(reference, amount);
}

export function isCurrentWeek(reference: Date): boolean {
	return isSameWeek(reference, currentWorkDay(), WEEK_OPTIONS);
}

export function weekLabel(reference: Date): string {
	const start = weekStart(reference);
	const end = addDays(start, 6);
	const startLabel = format(start, "d 'de' MMM", { locale: ptBR });
	const endLabel = format(end, "d 'de' MMM", { locale: ptBR });
	return `${startLabel} — ${endLabel}`;
}

export function dayRange(reference: Date): WeekRange {
	const day = dateToDateOnly(reference);
	return { from: day, to: day };
}
